<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <div
        style="text-align:center; font-size: 20px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
      >
        {{ $route.params.id ? $t('newsManagement.updateNews') : $t('newsManagement.addNews') }}
      </div>
    </div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group required">
            <label class="col-sm-3 control-label">{{
                $t("banner.image")
            }}</label>
            <div class="col-sm-6">
              <img
                id="news-img-id"
                :src="news.imageUrl !== null && news.imageUrl !== '' ? news.imageUrl : img_url.img_other_no_picture_available"
                class="news-img-class img-responsive"
                alt="news-img">
              <div style="padding-top: 6px; text-align: center">
                <input
                  id="upload-news-img"
                  type="file"
                  accept="image/*"
                  @change="onSelectNewsImg">
                <p>{{ $t('banner.clickImageToAddOrUpdate') }}</p>
                <span
                  v-if="news.imageUrl !== null && news.imageUrl !== ''"
                  class="remove-news-img"
                  @click="onClickRemoveNewsImg">{{ $t('common.delete') }}</span>
              </div>
            </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('banner.title')
          }}</label>
          <div class="col-sm-6">
            <input
              v-model="news.title"
              type="text"
              class="form-control"
              :placeholder="$t('banner.title')"
            />
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('newsManagement.categories')
          }}</label>
          <div class="col-sm-6">
            <select
              v-model="categorySelected"
              class="form-control"
              style="width: 100%;"
              >
              <option
                  v-for="category in categoriesList"
                  v-bind:key="category.id"
                  class="form-control"
                  v-bind:value="category.id"
              >{{ $t(category.name) }}</option>
              </select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">{{
            $t('banner.content')
          }}</label>
          <div class="col-sm-6">
            <trumbowyg
              v-model="news.content"
              :config="config"
              name="content"
            ></trumbowyg>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          @click="onBack"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>

        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onCreateNews"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import configuration from "../../lib/config";
import utils from "@/lib/utils";
import axios from "axios";
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";


export default {
  name: "ResidentsAdd",
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      isLoading: false,
      token: null,
      media_dns: null,
      news: {
        imageUrl: '',
        imageFile: '',
        title: null,
        content: ''
      },
      categoriesList: [{ id: null, name: 'Chọn chuyên mục' }],
      categorySelected: null,
      config: {
        // Get options from
        // https://alex-d.github.io/Trumbowyg/documentation
      },
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  watch: {
  },
  created () {
      this.GET_TOKEN_UPLOAD()
      .then(
        function(res) {
          this.token = res.token;
          this.media_dns = res.domain;
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    let newsId = this.$route.params.id
    if (newsId) {
      this.GET_NEWS_DETAIL({id: newsId}).then(
        function (res) {
          let data = res
          this.news.title = data.title
          this.news.imageUrl = data.image_url
          this.categorySelected = data.news_category
          this.news.content = data.content
        }.bind(this)
      )
    }
    this.GET_NEWS_CATEGORY_LIST().then(
        function (res) {
          this.categoriesList = [{ id: null, name: 'Chọn chuyên mục' }]
          for (let i = 0, size = res.length; i < size; i++) {
            let obj = {
              id: res[i].id,
              name: res[i].title
            }
            this.categoriesList.push(obj)
          }
        }.bind(this)
      ).catch(
        function () {
          this.categoriesList = []
        }.bind(this)
      )
  },
  mounted() {
    $(function () {
      $('#news-img-id').on('click', function () {
        $('#upload-news-img').click()
      })
    })
  },
  methods: {
    /**
     * Set default
     */
    setDefault: function () {
      this.news.title = null
      this.news.imageUrl = null
      this.news.imageFile = null
      this.categorySelected = null
    },
    /**
     * Create banner
     */
    onCreateNews: async function () {
        let filter = {
          title: this.news.title,
          imageUrl: this.news.imageUrl,
          newsCategoryId: this.categorySelected,
          content: utils.getCleanStringValue(this.news.content)
        }
        if (this.news.imageFile) {
          await this.uploadBannerImage()
          filter['imageUrl'] = this.news.imageUrl
        }
        let newsId = this.$route.params.id
        if (newsId) {
          this.UPDATE_NEWS({id: newsId, ...filter}).then(
            function () {
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        } else {
          this.CREATE_NEWS(filter).then(
            function () {
              this.setDefault()
              this.onClickRemoveNewsImg()
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        }
    },
    /**
     * Upload advertisement image
     */
    uploadBannerImage: async function () {
      let formData = new FormData()
      formData.append('file', this.news.imageFile)
      formData.append('directory', 'apartment/news')
      formData.append('forceOverride', true)
      await axios({
        method: 'POST',
        timeout: 6000,
        url: this.media_dns + '/api/v1/upload/',
        data: formData,
        headers: { Authorization: `JWT ${this.token}` }
      }).then(
        async function (res) {
          let data = res.data
          this.news.imageUrl = data.domain + data.url
        }.bind(this)
      ).catch(
        async function () {
          this.news.imageUrl = null
        }.bind(this)
      )
    },
    /**
     * Back
     */
    onBack: function () {
        window.history.back()
    },
    /**
     * Remove issuance img
     */
    onClickRemoveNewsImg: function () {
      let inputForm = $('#upload-news-img')
      inputForm.val('')
      this.news.imageFile = null
      this.news.imageUrl = null
    },
    /**
     * Select issuance img
     */
    onSelectNewsImg: function (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.getResultFile(files[0])
      this.news.imageUrl = URL.createObjectURL(files[0])
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.news.imageFile = file;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_TOKEN_UPLOAD",
      "CREATE_NEWS",
      "GET_NEWS_DETAIL",
      "UPDATE_NEWS",
      "GET_NEWS_CATEGORY_LIST"
    ]),
  },
  components: {
    Loading,
    "lte-core-alert": LTECoreAlert,
    Trumbowyg
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
.news-img-class{
  width: 100%;
  cursor: pointer;
  margin: auto;
  max-width: 250px;
  max-height: 300px;
}
input[type="file"] {
  display: none;
}
.remove-news-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-news-img:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/News/NewsAdd.vue